import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../lib/firebase";
import { adminWalletOp, callableMessage } from "../../services/callables";
import { Card } from "../../components/common/Card";
import { toast } from "react-hot-toast";

/** Pending manual top-up / dues reports (UPI ref or cash). Approve credits the wallet server-side. */
export const WalletRequestsPanel: React.FC<{ onChange?: () => void }> = ({ onChange }) => {
  const [rows, setRows] = useState<any[]>([]);
  const [busy, setBusy] = useState<string | null>(null);

  const load = async () => {
    try {
      const snap = await getDocs(query(collection(db, "wallet_requests"), where("status", "==", "pending")));
      setRows(snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) })));
    } catch (e) {
      console.warn("wallet_requests load failed", e);
    }
  };
  useEffect(() => { load(); }, []);

  const act = async (id: string, approve: boolean) => {
    setBusy(id);
    try {
      await adminWalletOp({ op: approve ? "approveWalletRequest" : "rejectWalletRequest", requestId: id });
      toast.success(approve ? "Approved and credited" : "Rejected");
      await load();
      onChange?.();
    } catch (e) {
      toast.error(callableMessage(e, "Action failed"));
    } finally {
      setBusy(null);
    }
  };

  if (rows.length === 0) return null;
  return (
    <Card className="p-4">
      <h3 className="font-bold text-gray-800 mb-3">Pending wallet top-up requests ({rows.length})</h3>
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.id} className="flex flex-wrap items-center justify-between gap-2 border rounded p-2 text-sm">
            <div>
              <div className="font-medium">₹{Number(r.amount || 0).toFixed(2)} · {r.userName || r.userPhone || r.userId}</div>
              <div className="text-xs text-gray-500">{r.method || "upi"} · ref {r.transactionId || "—"}</div>
            </div>
            <div className="flex gap-2">
              <button disabled={busy === r.id} onClick={() => act(r.id, true)} className="px-3 py-1 rounded bg-green-600 text-white disabled:opacity-50">Approve</button>
              <button disabled={busy === r.id} onClick={() => act(r.id, false)} className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50">Reject</button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
